import { useComputedColorScheme, useMantineColorScheme } from '@mantine/core';
import { useEffect } from 'react';
import { syncAppearance } from '@/utils/appearance';

export function AppearanceSync() {
	const { colorScheme } = useMantineColorScheme();
	const resolved = useComputedColorScheme('light');

	useEffect(() => {
		syncAppearance(colorScheme, resolved);
	}, [colorScheme, resolved]);

	return null;
}
